

export default {
    vi : {
        header: 'Tạo mật khẩu mới',
        description: 'Nhập mật khẩu có tối thiểu 8 ký tự bao gồm số, chữ hoa, chữ thường và ký tự đặc biệt.',
        password: 'Nhập mật khẩu',
        invalidPassword: 'Mật khẩu không hợp lệ',
        repassword: 'Nhập lại mật khẩu',
        invalidRepassword: 'Hai mật khẩu không trùng nhau',
        login: 'Quay lại đăng nhập'
    },
    en: {
        header: 'Create new password',
        description: 'Enter a password with at least 8 characters including numbers, lowercase letters, uppercase letters, and special characters.',
        password: 'Enter your new password',
        invalidPassword: 'Password is invalid',
        repassword: 'Enter password once more time',
        invalidRepassword: 'The two passwords do not match',
        login: 'Back to login'
    }
};
